"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneAuthViewContainer = void 0;
var _SourceProvider = require("../SourceProvider");
var _PhoneAuthView = require("./PhoneAuthView");
const PhoneAuthViewContainer = exports.PhoneAuthViewContainer = (0, _SourceProvider.SourceProvider)(_PhoneAuthView.PhoneAuthView);